import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const COMPONENT_CSS_CLASSNAME = 'evacuation-progress-bar-employees';
const bemE = suffix => `${COMPONENT_CSS_CLASSNAME}__${suffix}`;

const colors = ['#1dc992', '#ffa940', '#ff4d4f'];

const EvacuationProgressBarEmployees = ({ numbOfEmplArr }) => {
	const createProgressBar = arr => {
		const totalAmountOfEmpl = arr.reduce(
			(acc, numbOfEmpl) => acc + numbOfEmpl,
			0,
		);

		return totalAmountOfEmpl !== 0
			? arr.map((numbOfEmpl, i) => {
					const percentageRatio =
						(numbOfEmpl / totalAmountOfEmpl) * 100;
					const roundedPercantage =
						Math.round(
							(numbOfEmpl / totalAmountOfEmpl) * 100 * 10,
						) / 10;

					return (
						percentageRatio !== 0 && (
							<div
								key={i}
								className={bemE('info')}
								style={{
									width: `${percentageRatio}%`,
									backgroundColor: colors[i],
								}}
							>
								<p className={bemE('info-text')}>
									{numbOfEmpl}
									{i === 0 && (
										<span>
											Exited ({roundedPercantage}%)
										</span>
									)}
									{i === 1 && (
										<span>
											Evacuating ({roundedPercantage}%)
										</span>
									)}
									{i === 2 && (
										<span>
											Not Moved ({roundedPercantage}%)
										</span>
									)}
									{/* {(percentageRatio > 10) && `(${numbOfEmpl} ${numbOfEmpl <= 1 ? 'Person' : 'People'})`} */}
								</p>
							</div>
						)
					);
			  })
			: null;
	};

	return (
		<div className={COMPONENT_CSS_CLASSNAME}>
			{createProgressBar(numbOfEmplArr)}
		</div>
	);
};

EvacuationProgressBarEmployees.defaultProps = {
	numbOfEmplArr: [],
};

EvacuationProgressBarEmployees.propTypes = {
	numbOfEmplArr: PropTypes.array,
};

export default EvacuationProgressBarEmployees;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/components/evacuation-progress-bar-employees/index.js